import {
  BOT_API_COPY,
  BOT_REMOVAL_OUTCOME,
  BotRemovalOutcome,
  HTTP_FORBIDDEN,
  HTTP_NOT_FOUND,
  HTTP_UNAUTHORIZED,
} from '../constants/botApi';

/** A 2xx Remove Bot answer from either backend route (`routes/bots.js`, `routes/calendar.js`). */
export interface BotRemovalResponse {
  success?: boolean;
  alreadyEnded?: boolean;
  message?: string;
}

/** The outcome of a Remove Bot the backend accepted: it left now, or it had already left. */
export const removalOutcomeOf = (response: BotRemovalResponse | null | undefined): BotRemovalOutcome =>
  response?.alreadyEnded === true ? BOT_REMOVAL_OUTCOME.alreadyEnded : BOT_REMOVAL_OUTCOME.removed;

/** A rejected Remove Bot whose bot the backend no longer knows (404): it is not in the call. */
export const isBotGoneError = (error: unknown): boolean => getHttpStatus(error) === HTTP_NOT_FOUND;

/** The HTTP status on a rejected API call (apiService's ApiError), if it has one. */
export const getHttpStatus = (error: unknown): number | undefined => {
  const status = (error as { status?: unknown } | null | undefined)?.status;
  return typeof status === 'number' ? status : undefined;
};

/**
 * The message for an auth rejection: 401 means the session expired, 403 means
 * this user may not act on the bot (`forbiddenMessage` names the action).
 * Null for any other failure.
 */
export const getBotAuthErrorMessage = (error: unknown, forbiddenMessage: string): string | null => {
  const status = getHttpStatus(error);
  if (status === HTTP_UNAUTHORIZED) return BOT_API_COPY.sessionExpired;
  if (status === HTTP_FORBIDDEN) return forbiddenMessage;
  return null;
};

/** The message a rep sees for a failed bot call: the auth message, else `fallbackMessage`. */
export const describeBotApiError = (error: unknown, forbiddenMessage: string, fallbackMessage: string): string =>
  getBotAuthErrorMessage(error, forbiddenMessage) ?? fallbackMessage;
